import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { Field } from 'redux-form';
import Fields from 'components/Fields';
import { FieldCurrency } from 'components/Base';

interface Props {
  field: string;
  platform: any;
}

const useStyles = makeStyles({
  fields: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '1rem'
  },
  platformName: {
    fontWeight: 500
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  holdingsBox: {},
  field: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0.5rem 0'
  }
});

const Platform = ({ field, platform }: Props) => {
  const classes = useStyles();

  const { family_linked, isChecked } = platform;

  return (
    <div className={classes.fields}>
      <div className={classes.title}>
        <Typography className={classes.platformName}>
          {platform.name}
        </Typography>
        <Field name={`${field}.isChecked`} component={Fields.Checkbox} />
      </div>
      {isChecked && (
        <div className={classes.holdingsBox}>
          <div className={classes.field}>
            <span>Personal holdings</span>
            <FieldCurrency
              name={`${field}.personal_amount`}
              component={Fields.Text}
              clearfieldinform="platformHoldings"
            />
          </div>
          {family_linked && (
            <div className={classes.field}>
              <span>Family linked holdings</span>
              <FieldCurrency
                name={`${field}.family_linked_amount`}
                component={Fields.Text}
                clearfieldinform="platformHoldings"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Platform;
